// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerButton_loader__3R4tk","relative":"SpinnerButton_relative__xdfzo","hideText":"SpinnerButton_hideText__4Tx8-"};